import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { string, func, array, object, bool } from 'prop-types';
import { Modal } from 'antd';
import { withApollo } from 'react-apollo';
import { replace, get, map, omitBy, isEmpty, head, includes, isNil, size } from 'lodash';
import { FlexContainer, Row, Column, Button, FormInput, FormSelect, HasPermissions, Drawer, Icon, Text, If } from '../../common';
import { onlyNumbers } from '../../../utils/Regex';
import NewSectorPicking from './NewSectorPicking';
import GET_SECTOR_PICKING from '../../graphql/getSectorPicking';
import { Mutation } from '../../graphql';
import MUTATION_EXPORT_DARKSTORE_REPORT from '../../graphql/exportDarkstoreReport';
import PubSub from '../../../services/PubSub';
import { hasPermissionByResource } from '../../../utils/misc';

const SpaceBetween = styled.div`
    width: ${({ width }) => width};
`;

const ContainerWrapper = ({ children, fullWidth, ...more }) => (
    <FlexContainer
        border='2px solid #eaeaea'
        paddingHorizontal={13}
        paddingVertical={3}
        align='center'
        direction={fullWidth ? 'column' : 'row'}
        flex={1}
        display={fullWidth ? 'block' : 'flex'}
        {...more}
    >
        { children }
    </FlexContainer>
);

const Filters = ({ currentValue, onSubmit, salesChannelOptions, client, initialSaleChannelSelected, showMsgSelectFilter, email, setLoading, disableTrash, setDisableTrash, resetCurrentPage, session }) => {
    const [opened, setOpened] = useState(false);
    const [salesChannelSelected, setSalesChannel] = useState(initialSaleChannelSelected);
    const [sectorPickingSelected, setSectorPickingSelected] = useState(null);
    const [numqr, setNumQR] = useState(null);
    const [tray, setTray] = useState(null);
    const [sku, setSku] = useState(null);
    const [ean, setEan] = useState(null);
    const [position, setPosition] = useState(null);
    const [place, setPlace] = useState(null);
    const [sectorPickingOptions, setSectorPickingOptions] = useState(null);
    const [sectorsPickingData, setSectorsPickingData] = useState(null);
    const fullWidth = currentValue === '100%';
    const spaceBetweenWidth = fullWidth ? '0px' : '13px';
    const [showModal, setShowModal] = useState(false);
    const [reloadingFilters, setReloadingFilters] = useState(false);

    const buttomsContainerProps = !fullWidth ? { mL: 15, pL: 15, fitHeight: true, borderLeft: '1px solid #eaeaea', noFlex: true } : {};

    useEffect(() => {
        getSectorPicking();
    }, []);

    const onPressEnter = ({ key }) => {
        if (key === 'Enter') return onSubmit(cleanFiltersNull());
    };

    useEffect(() => {
        PubSub.dispatch('SET_RIGHT_HEADER', () => rightHeader());
    }, [salesChannelOptions]);

    const rightHeader = () => {
        return (
            <HasPermissions to={['darkstore-page:export']}>
                <FlexContainer direction='column'>
                    <FlexContainer direction='row'>
                        <Button width={100} text='Exportar' secondary onClick={() => setShowModal(true)} disabled={showMsgSelectFilter} />
                    </FlexContainer>
                </FlexContainer>
            </HasPermissions>
        );
    };


    useEffect(() => {
        return () => {
            PubSub.dispatch('SET_RIGHT_HEADER', () => null);
        }
    }, [])

    const ModalBodyComponent = ({ icon, firstLine, secondLine }) => (
        <>
            <Icon name={icon} color='#1fa02e' size={80} bottom={20} />
            <Text text={firstLine} strong size={16} />
            { secondLine && <Text text={secondLine} /> }
        </>
    );

    const modalBodyResolver = (status) => {
        switch (status) {
            case '400':
                return { icon: 'notConnection', firstLine: 'Ups, algo falló', secondLine: 'Por favor vuelve a intentarlo' };
            case '200':
                    return { icon: 'check-mark', firstLine: 'Se exportaron los registros seleccionados', secondLine: 'Serán enviados dentro de unos minutos a tu correo' };
            default:
                return { icon: 'export', firstLine: '¿Está seguro de exportar los datos?' };
        };
    };

    const modal = () => {
        return (
            <Modal
                visible={showModal}
                footer={null}
                closable={false}
                width={400}
                destroyOnClose
                onCancel={() => setShowModal(false)}
            >
                <Mutation mutation={MUTATION_EXPORT_DARKSTORE_REPORT}>
                    {({ data, loading, updateFn }) => {
                        const status = get(data, 'exportDarkstoreReport.internalCode');
                        const successful = includes([status], '200');
                        return (
                            <>
                                <FlexContainer style={{ margin: '30px 0px' }} align='center' direction='column'>
                                    { showModal && <ModalBodyComponent {...modalBodyResolver(status)} /> }
                                </FlexContainer>
                                <FlexContainer justify='center' align='center' style={{ width: '100%' }}>
                                    <Button
                                        link
                                        text={successful ? 'btn.action.close' : 'btn.action.cancel'}
                                        disabled={loading}
                                        style={{ width: '100px', margin: 0 }}
                                        onClick={() => setShowModal(false)}
                                    />
                                    { isNil(status) && <Button
                                        loading={loading}
                                        text={'btn.action.confirm'}
                                        style={{ width: '100px', margin: 0 }}
                                        disabled={loading}
                                        onClick={() => {
                                            updateFn({
                                                variables: {
                                                    filters: cleanFiltersNull(),
                                                    sendToExport: email
                                                }
                                            });
                                        }}
                                    /> }
                                </FlexContainer>
                            </>
                        );
                    }}
                </Mutation>
            </Modal>
        );
    };

    const toggleDrawer = () => setOpened(!opened);

    const cleanFilters = () => {
        const hasInitialSaleChannel = !isEmpty(initialSaleChannelSelected);
        const saleChannelFilter = hasInitialSaleChannel
            ? { comercial_policy: get(head(initialSaleChannelSelected), 'value') }
            : {};
        resetCurrentPage();
        setSalesChannel(hasInitialSaleChannel ? initialSaleChannelSelected : []);
        setSectorPickingSelected([]);
        setNumQR(null);
        setTray(null);
        setSku(null);
        setEan(null);
        setPosition(null);
        setPlace(null);
        onSubmit(saleChannelFilter);
        setReloadingFilters(true);
        setTimeout(() => {
            setReloadingFilters(false)
        }, 50);
    };

    const cleanFiltersNull = () => {
        const filters = {
            comercial_policy: isEmpty(salesChannelSelected) ? map(get(session, 'salesChannels'), 'id') : get(head(salesChannelSelected), 'value'),
            tray,
            numqr,
            sku,
            ean,
            position,
            place,
            sectorPicking: map(sectorPickingSelected, (item) => get(item, 'value'))
        };

        resetCurrentPage();

        return omitBy(filters, (item) => {
            return isEmpty(item);
        });
    };

    const getSectorPicking = async () => {
        client.query({ query: GET_SECTOR_PICKING, fetchPolicy: 'network-only' })
            .then(({ data }) => {
                const payload = get(data, 'getSectorPicking.payload');
                setSectorsPickingData(payload);
                const structureSectorPickingOptions = map(payload, (item) => {
                    return {
                        value: get(item, 'sectorPicking'),
                        label: get(item, 'sectorPicking')
                    };
                });

                setSectorPickingOptions(structureSectorPickingOptions);
            });
    };

    const fieldNumberHandler = (target, callback = () => {}, alphanumeric = false) => callback(replace(get(target, 'value', ''), alphanumeric ? '' : onlyNumbers, ''));

    const fields = [
        [
            {
                label: 'Local',
                options: salesChannelOptions,
                onChange: ({ value }) => isEmpty(initialSaleChannelSelected) && setSalesChannel(isEmpty(value) ? [] : [value]),
                value: salesChannelSelected,
                Component: FormSelect
            },
            {
                label: 'Sector de picking',
                multiple: true,
                value: sectorPickingSelected,
                options: sectorPickingOptions,
                onChange: ({ value }) => setSectorPickingSelected(value),
                Component: props => (
                    <>
                        { !isEmpty(sectorPickingOptions) && <FormSelect {...props} /> }
                    </>
                )
            },
            {
                label: 'Código SAP',
                placeholder: 'Ingrese código SAP',
                maxLength: 15,
                hook: setSku,
                value: sku
            },
            {
                label: 'EAN',
                placeholder: 'Ingrese EAN',
                hook: setEan,
                maxLength: 13,
                value: ean
            }
        ],
        [
            {
                label: 'Ubicación primer nivel',
                placeholder: 'Ingrese ubicación primer nivel',
                hook: setPosition,
                maxLength: 15,
                value: position
            },
            {
                label: 'Ubicación segundo nivel',
                placeholder: 'Ingrese ubicación segundo nivel',
                hook: setPlace,
                maxLength: 10,
                value: place
            },
            {
                label: 'Ubicación tercer nivel',
                placeholder: 'Ingrese ubicación tercer nivel',
                hook: setTray,
                maxLength: 10,
                value: tray
            },
            {
                label: 'QR',
                placeholder: 'Ingrese ID de QR',
                hook: setNumQR,
                maxLength: 18,
                value: numqr,
                alphanumeric: true
            }
        ]
    ];

    const buttons = [
        {
            text: 'Buscar',
            onClick: () => {
                onSubmit(cleanFiltersNull());
                setLoading(true);
            },
            top: 10
        },
        {
            text: 'Limpiar',
            onClick: () => cleanFilters()
        }
    ];

    return (
        <FlexContainer pY={23} direction='column'>
            <If
                condition={!reloadingFilters}
                then={
                    <ContainerWrapper fullWidth={fullWidth}>
                        <Column>
                            { map(fields, row => (
                                <Row noWrap={!fullWidth}>
                                    { map(row, ({ Component = FormInput, hook, alphanumeric, ...props }, index) => {
                                        const aditionalProps = get(props, 'placeholder', null) ? { onKeyPress: onPressEnter, onChange: ({ target }) => fieldNumberHandler(target, hook, alphanumeric) } : {};
                                        return (
                                            <>
                                                <Component
                                                    {...props}
                                                    {...aditionalProps}
                                                />
                                                <If
                                                    condition={size(row) !== index + 1}
                                                    then={<SpaceBetween width={spaceBetweenWidth} />}
                                                />
                                            </>
                                        );
                                    }) }
                                </Row>
                            )) }
                        </Column>
                        <Column {...buttomsContainerProps}>
                            { map(buttons, button => (
                                <Button
                                    bottom={10}
                                    {...button}
                                />
                            )) }
                        </Column>
                    </ContainerWrapper>
                }
            />
            <ContainerWrapper
                fullWidth={fullWidth}
                mT={10}
                paddingVertical={13}
                justify={hasPermissionByResource({ session, to: 'darkstore-page:delete-qr' }) ? 'space-between' : 'flex-end'}
            >
                <HasPermissions to={['darkstore-page:delete-qr']}>
                    <Button
                        link
                        onClick={() => setDisableTrash(!disableTrash)}
                        width={fullWidth ? undefined : 'fit-content'}
                    >
                        <Icon name='trash' size={18} color='#A4C735' />
                        <Text text='&nbsp;Activar/Desactivar' color='#A4C735' strong />
                    </Button>
                </HasPermissions>
                <HasPermissions to={['darkstore-page:create-sector-picking']} >
                    <Button
                        secondary
                        textTransform='uppercase'
                        text='Sector de picking'
                        onClick={() => toggleDrawer()}
                        width={fullWidth ? undefined : 'fit-content'}
                    />
                </HasPermissions>
            </ContainerWrapper>
            <Drawer
                values={['25%', '25%', '100%']}
                visible={opened}
                destroyOnClose
                onClose={toggleDrawer}
                minWidth={330}
            >
                <NewSectorPicking
                    toggleDrawer={toggleDrawer}
                    setOpened={() => setOpened(false)}
                    updateSelectedSectorPicking={() => getSectorPicking()}
                    sectorsPickingData={sectorsPickingData}
                />
            </Drawer>
            { modal() }
        </FlexContainer>
    );
};

Filters.propTypes = {
    currentValue: string,
    onSubmit: func,
    salesChannelOptions: array,
    client: object,
    initialSaleChannelSelected: array,
    showMsgSelectFilter: bool,
    email: string,
    setLoading: func,
    session: object,
    resetCurrentPage: func
};

export default withApollo(Filters);
